import { worker } from '~/mocks/browser';

export default defineNuxtPlugin(async () => {
  const __DEBUG__ = useRuntimeConfig().public.env === 'local';
  if (!__DEBUG__) return;

  await worker.start({ onUnhandledRequest: 'bypass' });
});
